import { useState } from 'react';
import { Link } from 'react-router-dom';
import { getHotComics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function HotSection() {
  const hotComics = getHotComics();

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            <i className="ri-fire-line text-accent-500 mr-2"></i>
            热门推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-1">最受欢迎的韩国漫画精选</p>
        </div>
        <Link
          to="/category/all"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5">
        {hotComics.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}